export enum UserImportType {
    Fullsync,
    Starters,
    Leavers
}